import React from 'react';
import PropTypes from 'prop-types';

const AudioOffPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M15.982 4.57L9.271 9.79a1 1 0 0 1-.614.21H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h5.657c.223 0 .439.075.614.21l6.711 5.221A1.251 1.251 0 0 0 18 26.444V5.556a1.25 1.25 0 0 0-2.018-.986zm13.255 6.576L26 14.383l-3.237-3.237a.5.5 0 0 0-.706 0l-.91.911a.497.497 0 0 0 0 .706L24.383 16l-3.236 3.237a.496.496 0 0 0 0 .705l.91.912a.5.5 0 0 0 .706 0L26 17.617l3.237 3.237a.498.498 0 0 0 .705 0l.912-.912a.5.5 0 0 0 0-.705L27.617 16l3.237-3.237a.501.501 0 0 0 0-.706l-.912-.911a.498.498 0 0 0-.705 0z"
    />
  );
};

AudioOffPath.propTypes = {
  fill: PropTypes.string,
};

export default AudioOffPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/audio-off.jsx